import { createFileRoute } from '@tanstack/react-router';
import { basicHead } from '../../utility/head';
import { FeatureArticle, featureSeo } from '../../components/FeatureArticle';
import { onTopicResponses } from '../../assets/data/features/on-topic-responses';

export const Route = createFileRoute('/_marketing/on-topic-responses')({
  component: () => <FeatureArticle data={onTopicResponses} />,
  ssr: true,
  loader: ({ location }) => ({
    pathname: location.pathname,
    seo: featureSeo(onTopicResponses),
  }),
  head: basicHead,
});
